import {
  EditGroupfolioRequest,
  EditGroupfolioResponse,
  GetGroupfolioResponse,
} from '@upright/common/model/input/company-groups/api-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { safeAssert } from '@upright/common/safe-assert';
import { editGroupfolio, getGroupfolio } from '.';

export function useGetGroupfolioQuery(groupfolioId: string | undefined) {
  return useQuery<GetGroupfolioResponse, Error>({
    queryKey: ['getGroupfolio', groupfolioId],
    queryFn: async () => {
      safeAssert(groupfolioId, 'groupId expected');
      return await getGroupfolio(groupfolioId);
    },
    enabled: groupfolioId !== undefined,
  });
}

export function useEditGroupfolioMutation(groupfolioId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<EditGroupfolioResponse, Error, EditGroupfolioRequest>({
    mutationKey: ['editGroupfolio'],

    mutationFn: async (request: EditGroupfolioRequest) => {
      safeAssert(groupfolioId, 'groupId expected');
      return await editGroupfolio(groupfolioId, request);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getGroupfolio'],
      });
    },
  });
}
